import { Alert } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useWatch } from 'react-hook-form';
import { buildScheduleNotice } from './nextSend';

const REFRESH_INTERVAL_MS = 30 * 1000;

/**
 * Mostra quando o envio recorrente vai disparar pela primeira vez com a
 * configuração atual do formulário. Atualiza sozinho: quem deixa o formulário
 * aberto até passar do horário precisa ver que o envio de hoje ficou para depois.
 */
const NextSendNotice = () => {
  const values = useWatch();
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const interval = setInterval(() => setNow(new Date()), REFRESH_INTERVAL_MS);
    return () => clearInterval(interval);
  }, []);

  const notice = buildScheduleNotice(values, now);
  if (!notice) { return null; }

  return (
    <Alert severity={notice.severity} sx={{ mt: 2, maxWidth: 700 }}>
      {notice.message}
    </Alert>
  );
};

export default NextSendNotice;
